import React, { Fragment, useContext, useEffect, useState } from "react";

import { LoadingContext } from "../Context";
import { CartDetailTypeEnum, CoachPlanType } from "../Structures";
import { ProfileLayout } from "../Container/Layout";
import {
  TransactionGetCoachPlans,
  TransactionPostCart,
} from "../Services/Transactions";
import { formatPrice, handleCopyText, Toast } from "../Utils";
import { Button, Empty } from "../Components/Base";

const CoachPlansPage = () => {
  const { loading, setLoading } = useContext(LoadingContext);

  // =========================================================================================================

  const [plansList, setPlansList] = useState<CoachPlanType[]>([]);

  // =========================================================================================================

  const handleAddToCart = (id: CoachPlanType["id"]) => {
    setLoading(true);
    TransactionPostCart(id, CartDetailTypeEnum.COACH_PLAN)
      .then(({ data: res }) => {
        if (res.transaction_status) {
          Toast("success", res.message);
        } else {
          Toast("error", res.message);
        }
      })
      .finally(() => setLoading(false));
  };

  // =========================================================================================================

  useEffect(() => {
    setLoading(true);
    TransactionGetCoachPlans()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setPlansList(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // =========================================================================================================

  return (
    <ProfileLayout>
      <Empty
        data={plansList}
        isLoading={loading}
        description="در حال حاضر اشتراکی وجود ندارد"
      >
        <div className="col-12">
          <div
            className="alert alert-warning text-justify"
            style={{ lineHeight: 2 }}
          >
            مربیان گرامی لطفا به نکات ذیل توجه فرمایید:
            <br /> ۱. هزینه اشتراک پنل خود با توجه به بازه زمانی و اطلاعات
            انتخاب شده را به حساب رئیس سبک ، استاد داود روستایی به شماره{" "}
            <strong
              className="cursor-pointer"
              onClick={() => handleCopyText("6274121168588192")}
            >
              {" "}
              6274121168588192{" "}
            </strong>{" "}
            واریز فرمایید. ( در صورت بروز هرگونه مشکل مرتبط با شماره کارت، می
            توانید از شماره کارت موجود در صفحه تماس با ما استفاده کنید.)
            <br /> ۲. حتما رسید تصویری واریز خود را پس از انتقال وجه ذخیره کنید
            تا در مراحل بعد در بارگذاری تصویر رسید در سایت با مشکل مواجه نشوید.
            <br /> ۳. فعال‌ سازی و داشتن اشتراک پنل مربی باعث صدور احکام ، شرکت
            در رویداد ها و فعال سازی نهایی هنرجویان آن مربی میشود و در غیر این
            صورت و عدم فعال بودن اشتراک مربی ، مسدود شدن تمام فعالیت های فوق به
            علاوه حذف از لیست مربیان به صورت سیستمی پس از پایان تاریخ اشتراک را
            در پی خواهد داشت.
            <br /> ۴. فعال بودن اشتراک می‌بایست مستمر و در تمامی ماه های سال
            باشد ، در غیر این صورت اشتراک پرداختی پس از چند ماه به عنوان بدهی
            ماه هایی که پرداخت نشده محسوب میشود.
          </div>
          <div className="row g-2">
            {plansList.map((plan) => (
              <div key={plan.id} className="col-sm-6 col-md-4">
                <div className="card border p-3 h-100">
                  <div className="position-relative">
                    <div
                      className="position-relative z-index-9"
                      style={{ height: 160 }}
                    >
                      <img
                        className="card-img h-100 w-100 object-fit-contain"
                        src={plan.thumbnail}
                        alt={plan.title}
                      />
                    </div>
                  </div>

                  <div className="card-body text-center p-3 px-0">
                    <h5 className="card-title">{plan.title}</h5>
                    <h6 className="mb-0 text-success">
                      {formatPrice(plan.price)} تومان
                    </h6>
                  </div>
                  <Button
                    onClick={() => handleAddToCart(plan.id)}
                    btnClass="w-100 btn-primary-soft mb-0"
                  >
                    <Fragment>
                      <i className="bi bi-cart me-2"></i>افزودن به سبد
                    </Fragment>
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Empty>
    </ProfileLayout>
  );
};

export default CoachPlansPage;
